import React, { FC, useState } from 'react';
import { LangChangeButton, LangChangeTitle, LangIconImg } from './ChangeLangDrop.styles';
import { langMenuDropArr } from '../../constans/flags';
import FlexibleDropdown from '../../HOC/FlexibleDropdown/FlexibleDropdown';
import { useLangManagement } from '../../hooks/useLangManagement';

interface IChangeLangDrop {
  anchor?: 'top' | 'bottom';
  positionX?: string;
  positionY?: string;
  width?: string;
}

const ChangeLangDrop: FC<IChangeLangDrop> = ({ anchor, positionX, positionY, width }) => {
  const [activeIcon, setActiveIcon] = useState(false);
  const { currentLanguageObject = {}, changeLanguage } = useLangManagement();

  return (
    <FlexibleDropdown
      activeTile={{ key: 'name', value: currentLanguageObject.name }}
      items={langMenuDropArr}
      setActiveIcon={setActiveIcon}
      getSelectedItem={(item: any) => changeLanguage(item.shortName)}
      {...{ anchor, positionX, positionY, width }}
    >
      <LangChangeButton data-testid="langIconButton" active={activeIcon}>
        <LangIconImg src={currentLanguageObject.icon} alt="" />
        <LangChangeTitle>{currentLanguageObject.shortDisplayName}</LangChangeTitle>
      </LangChangeButton>
    </FlexibleDropdown>
  );
};
export default ChangeLangDrop;
